import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const About = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section
      id="sobre"
      ref={ref}
      className="py-24 md:py-32 px-6 md:px-12 max-w-7xl mx-auto"
      data-testid="about-section"
    >
      <motion.div
        className="max-w-4xl mx-auto text-center"
        initial={{ opacity: 0, y: 50 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.8 }}
      >
        <div className="uppercase text-[#C9A646] font-sans text-xs md:text-sm tracking-[0.3em] mb-6">
          Nossa Essência
        </div>
        
        <h2
          className="font-serif text-3xl md:text-5xl text-white mb-8 tracking-tight"
          data-testid="about-title"
        >
          Onde o Tempo Encontra a Arte
        </h2>
        
        <p
          className="font-sans text-base md:text-lg text-[#A3A3A3] leading-relaxed mb-6"
          data-testid="about-description"
        >
          A ART TIME Watches não apenas vende relógios; nós curamos histórias. Especializados em peças originais, conectamos colecionadores a obras-primas do tempo com total transparência, exclusividade e confiança.
        </p>
        
        <p className="font-sans text-base md:text-lg text-[#A3A3A3] leading-relaxed">
          Cada relógio que passa por nossas mãos é mais do que um acessório — é um investimento, uma herança, uma expressão de caráter e sofisticação.
        </p>
      </motion.div>
    </section>
  );
};

export default About;
